import type { IconProps } from './types';

function LogIn01Icon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path d="M10 3H19V21H10" stroke={color} strokeWidth="1.5" />
      <path d="M4 11.75H11.4963" stroke={color} strokeWidth="1.5" />
      <path d="M8.74992 15.5L12.4999 11.75L8.74992 8" stroke={color} strokeWidth="1.5" />
    </svg>
  );
}

export { LogIn01Icon };
